import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import type { TServicePackage } from './service-data';
interface ServiceCardProps extends TServicePackage {
  index?: number;
  className?: string;
}
const ServiceCard = t0 => {
  const $ = _c(58);
  const {
    index: t1,
    className,
    name,
    cta,
    deliverables: t2,
    positioning,
    pricing: pricingRange,
    recommended
  } = t0;
  const index = t1 === undefined ? 0 : t1;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== className || $[1] !== index || $[2] !== name || $[3] !== positioning || $[4] !== pricingRange || $[5] !== recommended || $[6] !== t2) {
    const deliverables = t2 === undefined ? [] : t2;
    const t9 = recommended ? "border-accent/15 border bg-[linear-gradient(to_bottom_right,#080808_0%,#101010_72%,#1a1f00_100%)] text-white" : "bg-neutral-200 text-neutral-900";
    if ($[13] !== className || $[14] !== t9) {
      t8 = cn("relative flex min-h-152 w-full max-w-lg flex-col justify-between overflow-hidden px-6 py-8 transition-all duration-300 hover:scale-[0.995] sm:px-10", t9, className);
      $[13] = className;
      $[14] = t9;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    if ($[16] !== recommended) {
      t3 = recommended && <span className="font-primary bg-accent/10 text-accent absolute top-6 right-6 rounded-full px-3 py-1 text-xs font-semibold tracking-wider uppercase">Recommended</span>;
      $[16] = recommended;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    const t10 = recommended && "text-4xl font-black text-white sm:text-5xl";
    let t11;
    if ($[18] !== t10) {
      t11 = cn("font-primary text-3xl font-extrabold tracking-tight sm:text-4xl", t10);
      $[18] = t10;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    if ($[20] !== name || $[21] !== t11) {
      t4 = <h3 className={t11}>{name} Plan.</h3>;
      $[20] = name;
      $[21] = t11;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t12;
    if ($[23] !== positioning || $[24] !== recommended) {
      t12 = positioning && <p className={cn("text-base leading-relaxed font-medium text-neutral-600", recommended && "text-neutral-300")}>{positioning}</p>;
      $[23] = positioning;
      $[24] = recommended;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    const t13 = recommended && "text-white";
    const t14 = index === 1 && "text-2xl sm:text-3xl";
    let t15;
    if ($[26] !== t13 || $[27] !== t14) {
      t15 = cn("font-primary text-4xl font-black tracking-tight text-neutral-900 sm:text-5xl", t13, t14);
      $[26] = t13;
      $[27] = t14;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    let t16;
    if ($[29] !== index || $[30] !== recommended) {
      t16 = index !== 1 && <span className={cn("text-lg font-medium text-neutral-500", recommended && "text-neutral-400")}>onwards.</span>;
      $[29] = index;
      $[30] = recommended;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    let t17;
    if ($[32] !== pricingRange || $[33] !== t15 || $[34] !== t16) {
      t17 = <p className={t15}>{pricingRange}{" "}{t16}</p>;
      $[32] = pricingRange;
      $[33] = t15;
      $[34] = t16;
      $[35] = t17;
    } else {
      t17 = $[35];
    }
    if ($[36] !== t12 || $[37] !== t17) {
      t5 = <div className="mt-6 space-y-4">{t12}{t17}</div>;
      $[36] = t12;
      $[37] = t17;
      $[38] = t5;
    } else {
      t5 = $[38];
    }
    const t18 = recommended && "bg-white/10";
    let t19;
    if ($[39] !== t18) {
      t19 = cn("my-7 h-px w-full border-none bg-neutral-400/50", t18);
      $[39] = t18;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    if ($[41] !== t19) {
      t6 = <hr className={t19} />;
      $[41] = t19;
      $[42] = t6;
    } else {
      t6 = $[42];
    }
    t7 = deliverables.length > 0 && <ul className="space-y-3">{deliverables.slice(0, 5).map(item => <li key={item} className="flex items-center gap-3"><span className={cn("h-2 w-2 shrink-0 rounded-full bg-neutral-800", recommended && "bg-accent")} aria-hidden="true" /><span className={cn("text-lg font-medium text-neutral-800", recommended && "text-neutral-300")}>{item}</span></li>)}</ul>;
    $[0] = className;
    $[1] = index;
    $[2] = name;
    $[3] = positioning;
    $[4] = pricingRange;
    $[5] = recommended;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[43] !== t3 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6 || $[47] !== t7) {
    t9 = <div>{t3}{t4}{t5}{t6}{t7}</div>;
    $[43] = t3;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
    $[47] = t7;
    $[48] = t9;
  } else {
    t9 = $[48];
  }
  const t10 = recommended ? "bg-accent/85 hover:bg-accent focus-visible:outline-accent text-black" : "bg-neutral-900 text-white hover:bg-neutral-800 focus-visible:outline-neutral-900";
  let t11;
  if ($[49] !== t10) {
    t11 = cn("font-primary mt-8 w-full cursor-pointer rounded-full px-5 py-4 text-xl font-black transition-all duration-300 focus-visible:outline-2 focus-visible:outline-offset-2", t10);
    $[49] = t10;
    $[50] = t11;
  } else {
    t11 = $[50];
  }
  const t12 = cta || "Get Started";
  let t13;
  if ($[51] !== t11 || $[52] !== t12) {
    t13 = <button type="button" className={t11}>{t12}</button>;
    $[51] = t11;
    $[52] = t12;
    $[53] = t13;
  } else {
    t13 = $[53];
  }
  let t14;
  if ($[54] !== t13 || $[55] !== t8 || $[56] !== t9) {
    t14 = <div className={t8}>{t9}{t13}</div>;
    $[54] = t13;
    $[55] = t8;
    $[56] = t9;
    $[57] = t14;
  } else {
    t14 = $[57];
  }
  return t14;
};
export default ServiceCard;